import React, {useState} from "react";
import {createPortal} from "react-dom";
import {Container} from "../VpnSettingsSelector";
import {AnimatePresence} from "framer-motion";
import styled from "styled-components";

const platformData = {
    IOS: {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="black">
            <g clipPath="url(#clip0_1972_7000)">
                <path
                    d="M17.6492 6.818C17.5328 6.908 15.4775 8.062 15.4775 10.628C15.4775 13.596 18.0928 14.646 18.1711 14.672C18.159 14.736 17.7556 16.11 16.7922 17.51C15.9331 18.742 15.036 19.972 13.6711 19.972C12.3063 19.972 11.955 19.182 10.3794 19.182C8.84396 19.182 8.29802 19.998 7.04959 19.998C5.80116 19.998 4.93006 18.858 3.9285 17.458C2.76838 15.814 1.83105 13.26 1.83105 10.836C1.83105 6.948 4.36807 4.886 6.86493 4.886C8.19165 4.886 9.29757 5.754 10.1305 5.754C10.9233 5.754 12.1597 4.834 13.6691 4.834C14.2411 4.834 16.2964 4.886 17.6492 6.818ZM12.9526 3.188C13.5768 2.45 14.0183 1.426 14.0183 0.402C14.0183 0.26 14.0063 0.116 13.9802 0C12.9646 0.038 11.7563 0.674 11.0277 1.516C10.4557 2.164 9.92179 3.188 9.92179 4.226C9.92179 4.382 9.94788 4.538 9.95993 4.588C10.0242 4.6 10.1285 4.614 10.2329 4.614C11.1441 4.614 12.2902 4.006 12.9526 3.188Z"
                    fill="black"/>
            </g>
            <defs>
                <clipPath id="clip0_1972_7000">
                    <rect width="20" height="20" fill="black"/>
                </clipPath>
            </defs>
        </svg>,
        apps: [
            {
                name: "V2rayTun",
                url: "v2raytun://import/",
                rating: "4.7 • 1.2K Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "Hiddify",
                url: "hiddify://import/",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "V2Box",
                url: "v2box://import/",
                rating: "4.8 • 5 Ratings",
                hasAds: true,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },


        ],
        downloadApps: [
            {
                name: "V2rayTun",
                url: "https://apps.apple.com/lt/app/v2raytun/id6476628951",
                rating: "4.7 • 1.2K Ratings",
                hasAds: false
            },
            {
                name: "Hiddify",
                url: "https://apps.apple.com/us/app/hiddify/id6477891234",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false
            },
            {
                name: "V2Box",
                url: "https://apps.apple.com/us/app/v2box-v2ray-client/id6446814690",
                rating: "4.8 • 5 Ratings",
                hasAds: true
            },


        ]
    },
    Android: {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="black">
            <path
                d="M14.6025 8.62692C14.1433 8.62692 13.7698 8.25311 13.7698 7.79388C13.7698 7.33466 14.1433 6.96111 14.6025 6.96111C15.0618 6.96111 15.4353 7.33466 15.4353 7.79388C15.4353 8.25311 15.0618 8.62692 14.6025 8.62692ZM5.39747 8.62692C4.93823 8.62692 4.5647 8.25311 4.5647 7.79388C4.5647 7.33466 4.93823 6.96111 5.39747 6.96111C5.85669 6.96111 6.23023 7.33466 6.23023 7.79388C6.23023 8.25311 5.85669 8.62692 5.39747 8.62692ZM14.9012 3.6103L16.5657 0.727632C16.6611 0.561942 16.6043 0.350305 16.4389 0.254621C16.2735 0.159208 16.0616 0.215969 15.9659 0.381388L14.2806 3.30054C12.9919 2.71239 11.5445 2.38479 9.99999 2.38479C8.45554 2.38479 7.00813 2.71239 5.71938 3.30054L4.03411 0.381388C3.93843 0.215969 3.72652 0.159208 3.5611 0.254621C3.39568 0.350305 3.33865 0.561942 3.43433 0.727632L5.09878 3.6103C2.24072 5.16475 0.285965 8.05823 0 11.4766H20C19.7138 8.05823 17.759 5.16475 14.9012 3.6103Z"
                fill="black"/>
        </svg>,
        apps: [
            {
                name: "v2RayTun",
                url: "v2raytun://import/",
                rating: "4.6 • 10K+ Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "Hiddify",
                url: "hiddify://import/",
                rating: "4.8 • 5K+ Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },

        ],
        downloadApps: [
            {
                name: "v2RayTun",
                url: "https://play.google.com/store/search?q=v2raytun&c=apps",
                rating: "4.6 • 10K+ Ratings",
                hasAds: false
            },
            {
                name: "Hiddify",
                url: "https://play.google.com/store/apps/details?id=app.hiddify.com&hl",
                rating: "4.8 • 5K+ Ratings",
                hasAds: false
            }
        ]
    },
    MacOS: {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="black">
            <g clipPath="url(#clip0_1972_7000)">
                <path
                    d="M17.6492 6.818C17.5328 6.908 15.4775 8.062 15.4775 10.628C15.4775 13.596 18.0928 14.646 18.1711 14.672C18.159 14.736 17.7556 16.11 16.7922 17.51C15.9331 18.742 15.036 19.972 13.6711 19.972C12.3063 19.972 11.955 19.182 10.3794 19.182C8.84396 19.182 8.29802 19.998 7.04959 19.998C5.80116 19.998 4.93006 18.858 3.9285 17.458C2.76838 15.814 1.83105 13.26 1.83105 10.836C1.83105 6.948 4.36807 4.886 6.86493 4.886C8.19165 4.886 9.29757 5.754 10.1305 5.754C10.9233 5.754 12.1597 4.834 13.6691 4.834C14.2411 4.834 16.2964 4.886 17.6492 6.818ZM12.9526 3.188C13.5768 2.45 14.0183 1.426 14.0183 0.402C14.0183 0.26 14.0063 0.116 13.9802 0C12.9646 0.038 11.7563 0.674 11.0277 1.516C10.4557 2.164 9.92179 3.188 9.92179 4.226C9.92179 4.382 9.94788 4.538 9.95993 4.588C10.0242 4.6 10.1285 4.614 10.2329 4.614C11.1441 4.614 12.2902 4.006 12.9526 3.188Z"
                    fill="black"/>
            </g>
            <defs>
                <clipPath id="clip0_1972_7000">
                    <rect width="20" height="20" fill="black"/>
                </clipPath>
            </defs>
        </svg>,
        apps: [
            {
                name: "V2rayTun",
                url: "v2raytun://import/",
                rating: "4.7 • 1.2K Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "Hiddify",
                url: "hiddify://import/",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "V2Box",
                url: "v2box://import/",
                rating: "4.8 • 5 Ratings",
                hasAds: true,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },


        ],
        downloadApps: [
            {
                name: "V2rayTun",
                url: "https://apps.apple.com/lt/app/v2raytun/id6476628951",
                rating: "4.7 • 1.2K Ratings",
                hasAds: false
            },
            {
                name: "Hiddify",
                url: "https://apps.apple.com/us/app/hiddify/id6477891234",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false
            },
            {
                name: "V2Box",
                url: "https://apps.apple.com/us/app/v2box-v2ray-client/id6446814690",
                rating: "4.8 • 5 Ratings",
                hasAds: true
            },


        ]
    },
    Windows: {
        icon: <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
            <path
                d="M12 16L3 16 3 23.75 12 24.988zM12 5L3 6.25 3 14 12 14zM14 4.75L14 14 27 14 27 3zM14 16L14 25.25 27 27 27 16z"></path>
        </svg>,
        apps: [
            {
                name: "V2Box",
                url: "v2box://import/",
                rating: "4.8 • 5 Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "Hiddify",
                url: "hiddify://import/",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },

        ]
    },
    Other: {
        icon: <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABdklEQVR4nK3UPUiWURTA8R99CBUUZg4RuTSFJJUGYWDh2AdNQrTVUJNDDiqIKBjZqktTUwg6NkQu0RLRkls0FEgJ6aZRiQhpXDjCw/V9ej/qwOF5OB9/zj3n3Et1aUIHTvkP0ovv2A59g8P/AnxfgO3oaKOwFqygD8vx3cK7RoHtmMVdTOEWPmMdexsBduILPuEFvuFXHDsNqW7piuQrUdFkoY+PGgGORvISPmAaG2FbxYl6YMfxA2s4WrCPFKp8WQ/wSSRNZPb9WCxAr9UCOxTV/cSxCv7BAnChFuD1CJ4p8Z/OFr29GvA+NjFQ4t8Tx/6I37hdDdiDS3j2l5gzsejdOFcW1BpT3IrjphvyFEeyuGZcxOvY1bYy4FLWm5t4hedZ3IWwP8BbPC4DzmfArziPG1nc1QovUH8lYLq3eeBYtGEIw3iI8YI/DS9VmFZtl5zEHczFDqaENOnLuBea/neuZJp06mVNciBelLQiuezDWRyslPkHBRFovNw2BbAAAAAASUVORK5CYII="
            alt="linux"/>,
        apps: [
            {
                name: "V2Box",
                url: "v2box://import/",
                rating: "4.8 • 5 Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },
            {
                name: "Hiddify",
                url: "hiddify://import/",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false,
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            },

        ],
        downloadApps: [
            {
                name: "V2rayTun",
                url: "https://apps.apple.com/lt/app/v2raytun/id6476628951",
                rating: "4.7 • 1.2K Ratings",
                hasAds: false
            },
            {
                name: "Hiddify",
                url: "https://apps.apple.com/us/app/hiddify/id6477891234",
                rating: "4.9 • 2.3K Ratings",
                hasAds: false
            },
            {
                name: "V2Box",
                url: "https://apps.apple.com/us/app/v2box-v2ray-client/id6446814690",
                rating: "4.8 • 5 Ratings",
                hasAds: true
            },


        ]
    },
}


const AppBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    margin-bottom: 16px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 5px !important;
    }
`

const ServerListItem = styled.a`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;
    text-decoration: none;
    color: inherit;

    ${props => props.disabled && `
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    `}
    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }
`

const ServerListItemText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    p {
        margin: 0;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
    }

    @media (max-width: 453px) {
        p {
            max-width: 170px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    @media (max-width: 375px) {
        p {
            max-width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
`

const HeaderSection = styled.div`
    margin-bottom: 22px;

    h1 {
        color: #FFF;
        text-align: center;
        font-family: "VK Sans Display", sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: -0.24px;
        margin: 0;
    }
`

export const OpenInApp = ({
                              isRu,
                              platform,
                              config
                          }) => {
    const [appSelector, setAppSelector] = useState(false);

    const Apps = () => {
        return createPortal(
            <Container setShowItemSelector={setAppSelector}>
                <div
                    style={{
                        backfaceVisibility: "hidden",
                        bottom: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                        position: "absolute",
                        left: 0,
                        zIndex: 10000,
                        padding: 16,
                        backgroundColor: "rgba(22, 24, 26, 1)",
                        borderRadius: "28px 28px 0px 0px",
                        fontFamily: "\"VK Sans Display\", sans-serif",
                        opacity: 1
                    }}>
                    <HeaderSection>
                        <h1>{isRu ? "Открыть в приложении" : "Select App"}</h1>
                    </HeaderSection>
                    <AppBlock>
                        {platformData[platform].apps.map((app, index) => (
                            <ServerListItem
                                key={index}
                                target="_blank"
                                href={app.isSoon ? "#" : app.url + decodeURI(atob(config))}
                                disabled={app.isSoon}
                                onClick={app.isSoon ? (e) => e.preventDefault() : undefined}
                                rel="noreferrer">
                                <ServerListItemText>
                                    {app.icon}
                                    <div style={{display: "flex", flexDirection: "column", gap: "4px"}}>
                                        <p>{app.name}</p>
                                        <div
                                            style={{display: "flex", alignItems: "center", gap: "8px"}}>
                                        <span style={{
                                            color: "rgba(255, 255, 255, 0.5)",
                                            fontSize: "12px"
                                        }}>{app.rating}</span>
                                            {app.hasAds ? <span style={{
                                                color: "rgba(255, 255, 255, 0.5)",
                                                fontSize: "12px"
                                            }}>• Ads</span> : <span style={{
                                                color: "rgba(255, 255, 255, 0.5)",
                                                fontSize: "12px"
                                            }}>• No Ads</span>}
                                            {app.isSoon && <span style={{
                                                color: "rgba(255, 255, 255, 0.5)",
                                                fontSize: "12px",
                                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                                padding: "2px 8px",
                                                borderRadius: "4px"
                                            }}>Soon</span>}
                                        </div>
                                    </div>
                                </ServerListItemText>
                            </ServerListItem>
                        ))}
                    </AppBlock>
                    <HeaderSection style={{marginTop: "20px"}}>
                        <h1>{isRu ? "Скачать приложение" : "Download Apps"}</h1>
                    </HeaderSection>
                    <AppBlock>
                        {platformData[platform]?.downloadApps.map((app, index) => (
                            <ServerListItem
                                key={index}
                                target="_blank"
                                href={app.url}
                                rel="noreferrer">
                                <ServerListItemText>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white"
                                              strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <div style={{display: "flex", flexDirection: "column", gap: "4px"}}>
                                        <p>{app.name}</p>
                                        <div
                                            style={{display: "flex", alignItems: "center", gap: "8px"}}>
                                        <span style={{
                                            color: "rgba(255, 255, 255, 0.5)",
                                            fontSize: "12px"
                                        }}>{app.rating}</span>
                                            {app.hasAds ? <span style={{
                                                color: "rgba(255, 255, 255, 0.5)",
                                                fontSize: "12px"
                                            }}>• Ads</span> : <span style={{
                                                color: "rgba(255, 255, 255, 0.5)",
                                                fontSize: "12px"
                                            }}>• No Ads</span>}
                                        </div>
                                    </div>
                                </ServerListItemText>
                            </ServerListItem>
                        ))}
                    </AppBlock>
                </div>
            </Container>
            , document.body
        )
    }

    return (
        <>
            <button
                onClick={() => setAppSelector(true)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    height: "56px",
                    background: "white",
                    border: "none",
                    borderRadius: "8px",
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                    padding: "0 16px",
                }}>
                {platformData[platform].icon}
                {isRu ? "Открыть в приложении" : "Open in App"}
            </button>
            {appSelector && config && platform && <Apps />}
        </>
    )
}